import React, { useMemo, useState } from 'react';
import { WatchFeature } from '../components/WatchFeature';
import { ProductCard } from '../components/ProductCard';
import { NeedFromAbby } from '../components/NeedFromAbby';
import { TickDivider } from '../components/TickDivider';
import { usePageMeta } from '../hooks/usePageMeta';
import { products, shopCategories } from '../data/products';
import type { ProductCategory } from '../types/shop';
export function Shop() {
  usePageMeta('Shop | Objects for Every Hour', 'Zodiac jewelry, ritual pieces, crystals and altar objects from True Twelve, plus the upcoming True Twelve astrological watch.');
  const [filter, setFilter] = useState<ProductCategory | 'All'>('All');
  const visible = useMemo(() => filter === 'All' ? products : products.filter(p => p.categories.includes(filter)), [filter]);
  return <>
      <section aria-labelledby="shop-title" className="gutter pb-[clamp(3rem,6vw,6rem)] pt-[clamp(3rem,7vw,8rem)]" data-id="element-914" data-mp="2lh1bqhbs9r34">
        <div className="grid gap-8 lg:grid-cols-[minmax(0,1.3fr)_minmax(0,1fr)] lg:items-end" data-id="element-915" data-mp="3dkjrsrp8gnl1">
          <div data-id="element-916" data-mp="3ijejkj56hmha">
            <p className="t-label flex items-center gap-3 text-graphite" data-id="element-917" data-mp="3iiuzowvywo0m">
              <span className="t-numeral text-gold-deep" data-id="element-918" data-mp="3na3bu0oomnhh">II</span>
              <span aria-hidden="true" className="text-gold" data-id="element-919" data-mp="3namrfaqv0zsc">
                ·
              </span>
              The Shop
            </p>
            <h1 id="shop-title" className="t-display mt-6" data-id="element-920" data-mp="2ulfntxcjtk08">
              Objects for every hour.
            </h1>
          </div>
          <p className="t-lead max-w-[44ch] text-graphite lg:justify-self-end" data-id="element-921" data-mp="2zjqy296r9wiz">
            Jewelry, timepieces and ritual objects designed around the twelve, for the altar, the wrist and the everyday.
          </p>
        </div>
      </section>

      <WatchFeature tone="light" source="shop_watch" title="The True Twelve Watch." body="Built on the twelve. Join the waitlist for first access." data-id="element-922" data-mp="38j4750qywj36" />

      <section aria-labelledby="collection-heading" className="gutter section" data-id="element-923" data-mp="nu6oo0roqz1t">
        <h2 id="collection-heading" className="sr-only" data-id="element-924" data-mp="2jxupg8qdqve9">
          The collection
        </h2>
        <div className="sticky top-[clamp(4rem,3.6rem+1vw,5.25rem)] z-20 -mx-[var(--gutter)] bg-white/95 px-[var(--gutter)] py-4 backdrop-blur" data-id="element-925" data-mp="2fwsuw57er7im">
          <div className="flex items-center justify-between gap-6" data-id="element-926" data-mp="2tvs9sl54c81l">
            <ul className="no-scrollbar flex gap-2 overflow-x-auto" aria-label="Filter by category" data-id="element-927" data-mp="2owxrrlez6nij">
              {(['All', ...shopCategories] as const).map(c => <li key={c} className="shrink-0" data-id="element-928" data-mp="1w8juj7vpnv81">
                  <button type="button" aria-pressed={filter === c} onClick={() => setFilter(c)} className={`t-label h-10 border px-4 text-[0.64rem] transition-colors duration-150 ${filter === c ? 'border-charcoal bg-charcoal text-white' : 'border-[#8F877F] text-charcoal hover:border-charcoal'}`} data-id="element-929" data-mp="1w9uusxpy6kue">
                    {c}
                  </button>
                </li>)}
            </ul>
            <p className="hidden shrink-0 text-sm text-graphite md:block" aria-live="polite" data-id="element-930" data-mp="3tw43vnjml8ly">
              {visible.length} {visible.length === 1 ? 'piece' : 'pieces'}
            </p>
          </div>
        </div>
        <TickDivider className="mt-2" data-id="element-931" data-mp="3k61ctsw2e4q9" />

        <ul className="mt-10 grid gap-x-[clamp(1rem,1.6vw,2rem)] gap-y-[clamp(2.5rem,4vw,4.5rem)] [grid-template-columns:repeat(auto-fill,minmax(min(100%,clamp(9.5rem,19vw,26rem)),1fr))]" data-id="element-932" data-mp="3k744w454id7r">
          {visible.map(p => <li key={p.id} data-id="element-933" data-mp="gnhubi36ud8n">
              <ProductCard product={p} data-id="element-934" data-mp="2q30m15wjjav" />
            </li>)}
        </ul>
        <div className="mt-14" data-id="element-935" data-mp="2s5nicbrcwbd">
          <NeedFromAbby data-id="element-936" data-mp="7oe8458q5hpx">final product list, photos &amp; prices</NeedFromAbby>
        </div>
      </section>
    </>;
}